import { LocationActions, LocationActionTypes } from '@app/core/ngrx';

export interface LocationsState {
  loaded: boolean;
  pending: boolean;
  error: any;
  locations: any;
}

export const LOCATIONS_INITIAL_STATE: LocationsState = {
  loaded: false,
  pending: false,
  error: null,
  locations: null,
};

export const locationsReducer = (
  state: LocationsState = LOCATIONS_INITIAL_STATE,
  action: LocationActions,
): LocationsState => {
  switch (action.type) {
    case LocationActionTypes.LOAD_LOCATIONS:
      return {
        ...state,
        pending: true,
        loaded: false,
      };
    case LocationActionTypes.LOAD_LOCATIONS_SUCCESS:
      return {
        ...state,
        pending: false,
        loaded: true,
        locations: action.payload,
      };
    case LocationActionTypes.LOAD_LOCATIONS_ERROR:
      return {
        ...state,
        pending: false,
        loaded: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
